__turbopack_context__.v({
  "sectionPadding": "CAUWUW_sectionPadding",
});
